module.exports = "https://cdn.littlereply.com/tt/resource/lh_toast_warning.a06d3b5ba6cf7f86bb310ddcd062a45c.png";